// extracted by mini-css-extract-plugin
export default {"container__main":"ContentSug_container__main__yQnuQ","container__content":"ContentSug_container__content__Fz3t2","p":"ContentSug_p__OCsF+"};